import { Form, Modal, message, Select } from "antd"
import React, { useEffect } from "react"
import InputField from "../Common/InputField"
import { Invites } from "../../Apis/invitesApis"
import UserModalStructure from "../Common/UserModalStructure"
import { translations } from "../../utils/Translation/staticTranslation"

const UpdateUserRoleModal = ({
  isModalOpen,
  handleCancel,
  setUserInvites,
  selectedUser,
}) => {
  const [form] = Form.useForm()
  const lang = localStorage.getItem("language") || "ar"
  const modalUpdate = translations[lang]?.userPage?.ad_user_modal

  useEffect(() => {
    if (selectedUser) {
      form.setFieldsValue({
        email: selectedUser.email_address, // Set email field
        role: selectedUser.role, // Optional: set existing role
      })
    }
  }, [selectedUser, form])

  const onFinish = async (values) => {
    const payload = {
      role: values.role,
    }
    try {
      const response = await Invites.updateInvitedUserRole(
        payload,
        selectedUser.id
      )
      if (response.status === 200) {
        message.success(
          lang === "en" ? response.data.msg : response.data.msgArabic
        )
        setUserInvites((invites) =>
          invites.map((user) =>
            user.id === selectedUser.id ? { ...user, role: values.role } : user
          )
        )
        handleCancel()
      }
    } catch (error) {
      message.error(
        lang === "en"
          ? error.response.data.detail
          : error.response.data.detailArabic
      )
      console.error("Error deleting user:", error)
    }
  }

  return (
    <UserModalStructure
      isModalOpen={isModalOpen}
      handleCancel={handleCancel}
      title={modalUpdate?.update_user_role}
      subtitle={modalUpdate?.update_user_role}
      buttonText={modalUpdate?.update_role}
      onFinish={onFinish}
      isEmailDisabled={true}
      form={form}
      roleOptions={[
        { value: "ADMIN", label: "Admin" },
        { value: "VIEWER", label: "Viewer" },
      ]}
    />
  )
}

export default UpdateUserRoleModal
